import { toDateFormat } from '../../../utilities/dateFormat';
import { DateTime } from 'luxon';
export const checkScope = (value, min, max) => {
    if (!(value === null || value === void 0 ? void 0 : value.start) || !(value === null || value === void 0 ? void 0 : value.end))
        return { start: false, end: false };
    let start;
    let end;
    if (typeof value.start === 'string') {
        start = DateTime.fromFormat(value.start, 'LL/dd/yyyy')
            .startOf('day')
            .toJSDate();
    }
    else {
        start = toDateFormat.startOfDay(value.start);
    }
    if (typeof value.end === 'string') {
        end = DateTime.fromFormat(value.end, 'LL/dd/yyyy')
            .endOf('day')
            .toJSDate();
    }
    else {
        end = toDateFormat.endOfDay(value.end);
    }
    const scopeMessage = (date) => {
        var _a, _b;
        const underMinDate = (date === null || date === void 0 ? void 0 : date.getTime()) < ((_a = toDateFormat.startOfDay(min)) === null || _a === void 0 ? void 0 : _a.getTime());
        const exceedsMaxDate = (date === null || date === void 0 ? void 0 : date.getTime()) > ((_b = toDateFormat.endOfDay(max)) === null || _b === void 0 ? void 0 : _b.getTime());
        if (underMinDate) {
            return `Min date is ${DateTime.fromJSDate(min).toFormat('LL/dd/yyyy')}`;
        }
        if (exceedsMaxDate) {
            return `Max date is ${DateTime.fromJSDate(max).toFormat('LL/dd/yyyy')}`;
        }
        return false;
    };
    return {
        start: scopeMessage(start),
        end: scopeMessage(end),
    };
};
//# sourceMappingURL=checkScope.js.map